import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, PreguntasTipoEnum } from "@shared/enums";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";

export class PreguntaDistributionExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.DISTRIBUTION;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const fila =  super.generarFilaPregunta(datosEncuesta);
        if (fila.get(FilasExcel.MIN_MAX)!.includes(";")) {
            fila.set(FilasExcel.MIN_MAX, fila.get(FilasExcel.MIN_MAX)!.replace("0;", ""));
        }
        return fila;
    }

    protected generarItemsPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string>[] {
        const filasItems = super.generarItemsPregunta(datosEncuesta);
        filasItems.forEach(filaItem => {
            filaItem.set(FilasExcel.MIN_MAX, "");
        });
        return filasItems;
    }
}
